var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "promo-stripe",
      class: _vm.promoStripeColorClass,
      style: _vm.backgroundStyle,
      on: { click: _vm.onPromoStripeClick },
    },
    [_c("div", { staticClass: "promo-stripe-copy" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }